import angular from 'angular';

module.exports = angular.module('common.filters.yes_no', [])
.filter('yesNo', function() {
  return function(value) {
    if (value === undefined || value === null) return '—';
    return value ? 'Yes' : 'No';
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/yes_no.js
 **/